class StoresDelegate {
    setOpen(open) {
        this.setState((prevState) => {
            return { open };
        });
    }

    setRows(rows) {
        this.setState((prevState) => {
            return { rows };
        });
    }

    setTab(tab) {
        this.setState((prevState) => {
            return { tab };
        });
    }

    setStore(store) {
        this.setState((prevState) => {
            return { store };
        });
    }
}

export default StoresDelegate;
